module.exports = __webpack_public_path__ + "img/dental-calculus.47d936d1.svg";